/**
 * An expand/collapse toggle for "why did AI do this" — same open/onToggle/label shape as
 * `EyeToggle`, but a deliberately different glyph. `EyeToggle` means "reveal more of the
 * *current* live thing" everywhere it's used (`TaskDrawer`, `GoneQuiet`, `ClampedText`,
 * `QuickAddCard`'s "more") — an eye on `AiReasoningDisclosure` read as promising the same
 * thing about a task's *present* state, when what's actually behind it is a historical
 * explanation of a past decision. `Info` (ⓘ) is the same glyph `BadgeGlossary` already uses
 * for "here's an explanation of something," which is the more accurate — and more
 * universally recognized — signal for this one.
 */

import { Info } from "./icons";

export function InfoToggle({
  open,
  onToggle,
  label,
}: {
  open: boolean;
  onToggle: () => void;
  /** What is being explained, e.g. "why the AI filed this here". Reads after Show/Hide. */
  label: string;
}) {
  return (
    <button
      type="button"
      className="btn ghost small info-toggle"
      onClick={onToggle}
      aria-expanded={open}
      aria-label={`${open ? "Hide" : "Show"} ${label}`}
      title={`${open ? "Hide" : "Show"} ${label}`}
    >
      <Info size={16} />
    </button>
  );
}
